// What every landing page says is included / charged extra. Tolls are included in every price (owner,
// 2026-10-18). Must match TermsPage.js (waiting time,
// cancellation, hourly overtime, cleaning) and HelpPage.js (amenities, stops, tips). Don't promise
// anything here that the Terms don't.
import { HOURLY } from './prices';

export const BOOK_POINT = '/book?service=point';
export const BOOK_HOURLY = '/book?service=hour';

// The same numbers as TermsPage.js, for copy elsewhere (the travel guides) that needs them in a sentence.
export const AIRPORT_FREE_WAIT_MIN = 60;
export const POINT_FREE_WAIT_MIN = 15;
export const FREE_CHANGE_HOURS = 1;

const TOLLS = 'All bridge and tunnel tolls';
const COMFORTS = 'Complimentary water, Wi-Fi, a phone charger and help with your bags';
// What every ride comes with, for the guides' "what you get" list. Water, Wi-Fi and the detailed car
// match HelpPage.js (amenities, vehicles); the suited chauffeur is from the owner (2026-10-25) and is
// in the Help amenities answer too.
export const PERKS = [
  'Complimentary bottled water',
  'Free Wi-Fi and a phone charger',
  'A clean, professionally detailed car',
  'A professional chauffeur in a suit',
  'Help with your bags',
];

const CHAUFFEUR = 'Your chauffeur’s name, vehicle and plate in the app, and a direct line to call or message them';
const CANCEL = `Free changes and cancellation up to ${FREE_CHANGE_HOURS} hour before pickup, with a full refund for card payments`;

export const INCLUDED = {
  airport: [
    'A professional chauffeur and a private Sedan or SUV, door to door',
    TOLLS,
    'Flight tracking: add your flight number and your chauffeur follows delays and early arrivals',
    `${AIRPORT_FREE_WAIT_MIN} minutes of free waiting after your flight lands, for baggage claim and customs`,
    COMFORTS,
    CHAUFFEUR,
    CANCEL,
  ],
  point: [
    'A professional chauffeur and a private Sedan or SUV, door to door',
    TOLLS,
    `${POINT_FREE_WAIT_MIN} minutes of free waiting after your scheduled pickup time`,
    'Every stop you add when you book, priced before you pay',
    COMFORTS,
    CHAUFFEUR,
    CANCEL,
  ],
  hourly: [
    'A professional chauffeur and a private Sedan or SUV for the hours you book',
    TOLLS,
    HOURLY ? `${HOURLY.sedan.includedMilesPerHour} miles per booked hour, and as many stops as you like within your time` : 'As many stops as you like within your time',
    'Your chauffeur waits for you between stops, at no extra charge, within your booked time',
    COMFORTS,
    CHAUFFEUR,
    CANCEL,
  ],
};

export const WAITING = 'Waiting beyond the free time: $1.00 per minute in a Sedan, $1.50 per minute in an SUV';
const TIP = 'A tip for your chauffeur is optional; you can add one when you book';
const CLEANING = 'Cleaning or damage fees, only if the vehicle needs more than normal cleaning or is damaged';

export const EXTRAS = {
  airport: [WAITING, TIP, 'Extra stops on the way, if you add them (the price updates before you pay)', CLEANING],
  point: [WAITING, TIP, CLEANING],
  hourly: [
    'Extra time if your ride runs more than 15 minutes past the hours you booked',
    HOURLY ? `Miles beyond the included miles: $${HOURLY.sedan.overMileRate} per mile in a Sedan, $${HOURLY.suv.overMileRate} per mile in an SUV` : 'Miles beyond the included miles',
    TIP,
    CLEANING,
  ],
};
